<template>
  <q-select
    v-model="value_"
    :multiple="false"
    filterable
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <q-option
      v-for="item in items"
      :key="item.key"
      :label="item.caption"
      :value="item.key"
    />
  </q-select>
</template>

<script>


  export default {
    name: "QEnumSelector",

    props: {
      value: {
        required: true
      },

      disabled: {type: Boolean, default: false},
      placeholder: {default: '', type: String},
      plugin: {required: true, type: String},
      model: {required: true, type: String},
      enumType:{required: true, type: String}
    },

    data() {
      return {
        value_: {},
        items: []
      }
    },

    watch: {
      value_() {
        this.$emit('input', this.value_);
      },
      value() {
        this.value_ = this.value;
      }
    },
    created() {
      this.value_ = this.value;
    },

    mounted() {
      this.fetchItems();

    },

    methods: {
      fetchItems() {
        this.$service(this.plugin, this.model, 'getEnumItems', {
          enumType: this.enumType
        }).then((response) => {

          this.items = response.result.items;
        }).catch(() => {
        });
      }
    }

  }
</script>

<style scoped>

</style>